import vanillaSelectBox from '../components/select';

class ScProductsAttributeFilter {
  constructor(domSelector, productGroup) {
    this.domSelector = domSelector;
    this.selects = domSelector.querySelectorAll('.product-detail__filter-items .filter-item select');
    this.productGroup = productGroup;

    if(!this.domSelector) {
      return;
    }

    this.init();
  }

  searchInMultidimensionalArray(data, ...searchStrings) {
    for (let i = 0; i < data.length; i++) {
      let match = true;
      for (let j = 0; j < searchStrings.length; j++) {
        if (data[i][j] !== searchStrings[j]) {
          match = false;
          break;
        }
      }
      if (match) {
        return i; // Rückgabe des Index des gefundenen Eintrags
      }
    }
    return -1; // -1 wird zurückgegeben, wenn kein passender Eintrag gefunden wurde
  }

  extractAttributeValues(elements, skipAttributes = []) {
    const attributeValues = [];

    for (let i = 0; i < elements.length; i++) {
      const elementAttributes = elements[i].attributes;
      const entry = [];
      for (let j = 0; j < elementAttributes.length; j++) {
        const attribute = elementAttributes[j];
        if (!skipAttributes.includes(attribute.name)) {
          entry.push(attribute.value);
        }
      }
      attributeValues.push(entry);
    }

    return attributeValues;
  }

  getGroupeElementByAttributes(arr) {
    // Extrahieren der Werte der Attribute (ohne "data-id") aus den Elementen
    const attributeValues = this.extractAttributeValues(this.productGroup, ['class']);

    // Durchsuchen des mehrdimensionalen Arrays nach einem passenden Eintrag
    const result = this.searchInMultidimensionalArray(attributeValues, ...arr);


    if(result >= 0) {
      return this.productGroup[result].querySelector('.button');
    } else {
      return;
    }
  }

  getElementBySelectedValues(selects) {
    const attrArr = [];
    selects.forEach((select, i) => {
      attrArr[i] = select.value;
    });

    return this.getGroupeElementByAttributes(attrArr);
  }

  addListener(selects) {
    selects.forEach((select) => {
      select.addEventListener('change', (event) => {
        const eventElement = this.getElementBySelectedValues(this.selects);
        if(eventElement) {
          eventElement.click();
        }
      })
    });
  }

  selectOptionHandler(select, selectBox) {
    const options = select.querySelectorAll('option');
    const boxOptions = selectBox.querySelectorAll('li');
    let activeOpt = select.selectedIndex;

    boxOptions.forEach((option, i) => {
      option.addEventListener('click', () => {
        if((activeOpt >= 0) && (activeOpt !== i)) {
          options[activeOpt].removeAttribute('selected');
        }

        if(activeOpt !== i) {
          options[i].setAttribute('selected', '');
          activeOpt = i;
        }
      });
    });
  }

  renderSelects(selects) {
    selects.forEach((select) => {
      const selectId = '#' + select.id;
      const selectLabel = select.parentElement.querySelector('label');
      const selectLabelContent = selectLabel.textContent;

      if(selectLabel) {
        selectLabel.style.display = 'none';
      }

      new vanillaSelectBox(selectId,{
        'maxHeight':300,
        'placeHolder': selectLabel ? selectLabelContent : '',
        'disableSelectAll': true,
        'selectedClass': false,
        'keepInlineStyles': false,
        'translations': { 'all': 'All', 'items': 'Ausgewählt' }
      });

      this.selectOptionHandler(select, select.parentElement.querySelector('.vsb-main'));
    });
  }

  init() {
    this.renderSelects(this.selects);
    this.addListener(this.selects);
  }


}

export default ScProductsAttributeFilter;
